/**
 * Display preferences: transliteration scheme, tone markers and theme.
 *
 * These used to live in a fullscreen dialog opened from the header. A page
 * gives the choices room to explain themselves — each scheme now carries a
 * description and a live sample — and gives the settings a URL.
 *
 * noindex: the page has no content a search result could usefully offer, and
 * everything on it is about one browser. src/server/sitemap.ts builds from a
 * fixed page list rather than scanning routes, so nothing should be added
 * there.
 */

import { createFileRoute } from '@tanstack/react-router'
import PreferencesPage from 'pages/preferences'

export const Route = createFileRoute('/preferences')({
   head: () => ({
      meta: [{ title: 'Preferences | thai2english' }, { name: 'robots', content: 'noindex' }],
   }),
   component: PreferencesPage,
})
